import React from 'react';
import KioskQuestionnaireScoring from '../../containers/Questionnaires/KioskQuestionnaireScoring';

export class KioskQuestionnaireScoringPage extends React.Component {
  render() {
    return <KioskQuestionnaireScoring />;
  }
}
